/**
 * @fileoverview ESM mirror of ../getAppPolicy.js.
 * @module @puffin-core/cross-app-policy/getAppPolicy
 */

import { APP_REGISTRY } from './registry.js';

function getAppPolicy(appKey) {
  if (typeof appKey !== 'string' || appKey.length === 0) return null;
  if (!Object.prototype.hasOwnProperty.call(APP_REGISTRY, appKey)) return null;
  return APP_REGISTRY[appKey];
}

function listSiblingApps(currentAppKey) {
  if (typeof currentAppKey !== 'string' || currentAppKey.length === 0) return [];
  if (!Object.prototype.hasOwnProperty.call(APP_REGISTRY, currentAppKey)) return [];
  const siblings = Object.keys(APP_REGISTRY)
    .filter((key) => key !== currentAppKey)
    .sort()
    .map((key) => APP_REGISTRY[key]);
  return Object.freeze(siblings);
}

export { getAppPolicy, listSiblingApps };
